import { StandardEvents } from '@shopify/events';

class MVStockIndicator extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html || (detail.productId && String(detail.productId) !== this.dataset.productId)) return;
        const next = detail.html.querySelector(`mv-stock-indicator[data-product-id="${this.dataset.productId}"]`);
        if (!next) return;
        this.className = next.className;
        this.setAttribute('aria-label', next.getAttribute('aria-label') || 'Disponibilité');
        this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[mv-stock-indicator] Variant update failed');
      });
  };
}

if (!customElements.get('mv-stock-indicator')) {
  customElements.define('mv-stock-indicator', MVStockIndicator);
}
